export default "__VITE_ASSET__A45Hd6dj__"